import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import I18nTextField from "../../i18n-text-field";
import {RENDERER_TYPES} from "../constants";
import {isFieldMultilang, isFieldMultirows, pruneEmptyValues} from "../utils";

export const I18nTextAreaTester = schemaMatches(
  schema => schema.renderer === RENDERER_TYPES.i18nTextArea || (isFieldMultilang(schema) && isFieldMultirows(schema))
);

export const I18nTextAreaRenderer = withJsonFormsControlProps(
  ({label, data, handleChange, path, uischema, schema, required, visible, errors}) => {
    if (!visible) {
      return null;
    }

    const rows = uischema?.options?.rows || schema?.options?.rows || 4;

    return (
      <I18nTextField
        fullWidth
        multiline
        required={required}
        error={!!errors}
        helperText={errors}
        rows={rows}
        label={label}
        variant="outlined"
        value={data}
        onChange={value => handleChange(path, pruneEmptyValues(value))}
        className="custom-json-forms__renderers__i18n-textarea"
      />
    );
  }
);
